"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmColumn = exports.SmGrid = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
exports.SmGrid = react_1.default.forwardRef((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement("div", { className: "o-container" },
        react_1.default.createElement("div", Object.assign({}, props, { ref: ref, className: (0, classnames_1.default)('o-grid', className) }), children)));
});
exports.SmColumn = react_1.default.forwardRef((_a, ref) => {
    var { sm, md, lg, className, cols = 1, children } = _a, props = __rest(_a, ["sm", "md", "lg", "className", "cols", "children"]);
    const smCols = sm ? `o-grid__col-sm-${sm}` : '';
    const mdCols = md ? `o-grid__col-md-${md}` : '';
    const lgCols = lg ? `o-grid__col-lg-${lg}` : '';
    const columnClassnames = (0, classnames_1.default)(`o-grid__col-${cols}`, `${smCols}`, `${mdCols}`, `${lgCols}`, className);
    return (react_1.default.createElement("div", Object.assign({}, props, { ref: ref, className: columnClassnames }), children));
});
//# sourceMappingURL=index.js.map